<template>
  <div class="column is-12">
    <div class="title is-5">Subiendo Fotos</div>
    <nav class="level is-mobile">
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Velocidad</p>
          <p v-if="velocidadSubidaEnKbs" class="title is-4">{{velocidadSubidaEnKbs}} KB/s</p>
        </div>
      </div>
      <div class="level-item has-text-centered">
        <div>
          <p class="heading">Tiempo Restante</p>
          <p v-if="tiempoRestanteSubida" class="title is-4">{{tiempoRestanteSubida}}</p>
        </div>
      </div>
    </nav>
    <progress class="progress is-primary" v-bind:value="porcentajeFotosSubidas" max="100"></progress>
  </div>
</template>

<script>
export default {
  name: 'ProgresoSubida',
  props: {
    uploader: {
      type: Object,
      required: true
    }
  },
  methods: {
    segundosToHHMMSS (segundos) {
      var secNum = parseInt(segundos, 10)
      var hours = Math.floor(secNum / 3600)
      var minutes = Math.floor((secNum - hours * 3600) / 60)
      var seconds = secNum - hours * 3600 - minutes * 60

      if (hours < 10) {
        hours = `0${hours}`
      }
      if (minutes < 10) {
        minutes = `0${minutes}`
      }
      if (seconds < 10) {
        seconds = `0${seconds}`
      }
      return `${hours}:${minutes}:${seconds}`
    }
  },
  computed: {
    velocidadSubidaEnKbs () {
      return Math.round(this.uploader.total.bytesPerSec / 1024)
    },
    porcentajeFotosSubidas () {
      return Math.round(
        (this.uploader.total.loaded / this.uploader.total.size) * 100
      )
    },
    tiempoRestanteSubida () {
      if (this.uploader.total.size - this.uploader.total.loaded > 0) {
        return this.segundosToHHMMSS(
          Math.round(
            (this.uploader.total.size - this.uploader.total.loaded) /
              1024 /
              this.velocidadSubidaEnKbs
          )
        )
      } else {
        return '-'
      }
    }
  }
}
</script>
